import IndustrySolutionPage from '../components/IndustrySolutionPage';
import { datacenterData } from '@/mocks/industrySolutionsData';

export default function DatacenterSolutionPage() {
  return <IndustrySolutionPage data={datacenterData} />;
}